import { Component } from '@angular/core';
import { CampaignService } from '@app/services/campaigns/campaign.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sent-mails',
  standalone: false,
  templateUrl: './sent-mails.component.html',
  styleUrl: './sent-mails.component.css'
})
export class SentMailsComponent {
  memberId: number = 0;
  campaigns: any[] = [];
  constructor(private campaignService: CampaignService, private activatedRoute: ActivatedRoute) {
    this.activatedRoute.params.subscribe(params => {
      this.memberId = +params['id'];
      this.campaignService.getCampaignsForMember(this.memberId).subscribe((camps: any[]) => {
        
        this.campaigns = camps;
      });
    });
  }
  }
